<template>
  <div class="wrapper">
    <v-top></v-top>
    <v-head></v-head>
    <!-- <div class="content-box" :class="{'content-collapse':collapse}"> -->
    <div class="content">
      <transition name="move" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <!-- </div> -->
    <v-footer></v-footer>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import vTop from "@/common/Top.vue";
import vHead from "./Header.vue";
import vFooter from "./Footer.vue";
import bus from "./bus";
export default {
  data() {
    return {
      collapse: false
    };
  },
  components: {
    vTop,
    vHead,
    vFooter
  },
  created() {
    globalApi.GetWebInfoAndUserSessionInfoFromServer(false);
    document.body.style.zoom = "normal"; //避免zoom尺寸叠加
    let scale = window.screen.width / 1904;
    document.body.style.zoom = scale;
  }
};
</script>
<style>
.wrapper {
  background: #f6f9fa;
  width: 100%;
}
.content {
  background: #f6f9fa;
}
.body {
  background: #f6f9fa;
}
</style>

